import React from 'react';
import { Button } from 'antd';
import classnames from 'classnames';
import './styles.less';

function OmiButton(props) {
  const { children, loading, className, ...rest } = props;
  return (
    <Button {...rest} className={classnames('omi-btn flex items-center', className)}>
      {loading && (
        <div className="loading">
          <div className="circle" />
          <div className="circle" />
          <div className="circle" />
        </div>
      )}
      {children}
    </Button>
  );
}

export default OmiButton;
